(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!window.ksCartFloatingCountBound) {
    window.ksCartFloatingCountBound = true;

    document.addEventListener('theme:cart:added', () => {
      const countEl = document.querySelector('[data-cart-floating-count]');
      const cart = document.querySelector('cart-items[data-cart-drawer]');

      if (!countEl || !cart) return;

      const fields = cart.querySelectorAll('[data-quantity-field]');
      const drawerRendered = Boolean(cart.querySelector('[data-items-holder]'));

      if (!drawerRendered && fields.length === 0) return;

      const qty = Array.from(fields).reduce((total, input) => {
        return total + (parseInt(input.value, 10) || 0);
      }, 0);

      countEl.textContent = String(qty);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
